module.exports = __webpack_public_path__ + "img/stamp-voided.f4b61a79.png";